import { StyleSheet } from "react-native";

const sombraCard = {
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.06,
  shadowRadius: 12,
  elevation: 3,
};

export default StyleSheet.create({
  container: {
    width: "100%",
    alignItems: "center",
    minHeight: "100%",
  },
  larguraConteudo: {
    width: "100%",
    maxWidth: 560,
    paddingHorizontal: 16,
  },
  conteudo: {
    marginTop: -52,
  },

  // Cards de ação (Agendamentos / Mensalista)
  cardAcao: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 20,
    borderWidth: 1,
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginBottom: 14,
    ...sombraCard,
  },
  iconeCardAcao: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 14,
  },
  tituloCardAcao: {
    fontSize: 18,
    fontWeight: "700",
  },
  subtituloCardAcao: {
    fontSize: 13,
    marginTop: 2,
  },

  // Card de assinaturas
  badgeClube: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingVertical: 5,
    paddingHorizontal: 12,
    borderRadius: 20,
    backgroundColor: "rgba(255,255,255,0.12)",
    marginBottom: 14,
  },
  textoBadgeClube: {
    color: "#E3BF7A",
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 1.5,
  },
  tituloAssinatura: {
    color: "#fff",
    fontSize: 26,
    fontWeight: "800",
    lineHeight: 30,
  },
  textoAssinatura: {
    color: "rgba(255,255,255,0.8)",
    fontSize: 14,
    marginTop: 10,
  },
  linhaChips: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 16,
  },
  chip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.12)",
  },
  textoChip: {
    color: "#fff",
    fontSize: 12,
    fontWeight: "600",
  },
  rodapeAssinatura: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderTopWidth: 1,
    borderTopColor: "rgba(255,255,255,0.12)",
    backgroundColor: "rgba(0,0,0,0.15)",
  },
  textoRodapeAssinatura: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "700",
  },
  botaoSetaAssinatura: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: "#E3BF7A",
    alignItems: "center",
    justifyContent: "center",
  },

  // Localização
  cardLocalizacao: {
    width: "100%",
    borderRadius: 20,
    borderWidth: 1,
    padding: 16,
    marginTop: 14,
    ...sombraCard,
  },
  cabecalhoLocalizacao: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  linhaCentralizada: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  tituloLocalizacao: {
    fontSize: 17,
    fontWeight: "700",
  },
  linkMapa: {
    fontSize: 13,
    fontWeight: "700",
  },
  containerMapa: {
    borderRadius: 14,
    overflow: "hidden",
  },
  textoEndereco: {
    fontSize: 13,
    textAlign: "center",
    marginTop: 12,
  },

  // Rodapé
  tituloRodape: {
    fontSize: 20,
    fontWeight: "800",
  },
  subtituloRodape: {
    fontSize: 13,
    marginTop: 4,
  },
  linhaRedes: {
    flexDirection: "row",
    gap: 14,
    marginTop: 16,
  },
  botaoRede: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: "rgba(255,255,255,0.14)",
    alignItems: "center",
    justifyContent: "center",
  },
  textoVersao: {
    fontSize: 12,
    marginTop: 18,
  },
});
